import { useTranslation } from "react-i18next";

import { useMemo, useState } from "react";

import { useSelector } from "react-redux";

import { useGetAllToDosQuery } from "@/pages/Private/redux/to-do/to-do.api";
import { usePageTitle } from "@/utils/usePageTitle";

import { toDoSelector } from "@/pages/Private/redux/to-do/to-do.slice";

import ToDoFilterPanel from "../ToDoList/components/ToDoFilterPanel";
import { ToDoType } from "../ToDoList/enum/ToDoType.enum";
import EditableToDoItemList from "./components/EditableToDoItemList";
import { SORT_BY_ALL } from "./components/SortDropDown";

export default function ManageToDos() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-to-dos.${key}`);
	const [filterTagId, setFilterTagId] = useState<number>(-1);
	const [sortType, setSortType] = useState<ToDoType | typeof SORT_BY_ALL>(SORT_BY_ALL);
	const { isLoading } = useGetAllToDosQuery();
	const [editingToDoId, setEditingToDoId] = useState(-1);
	const toDos = useSelector(toDoSelector);
	const [search, setSearch] = useState<string>("");

	const handleOnSearch = (search: string) => {
		setSearch(search);
	};

	usePageTitle(ts("title"));

	const filteredData = useMemo(() => {
		setEditingToDoId(-1);

		return toDos?.filter((item) => {
			const matchesTag = filterTagId === -1 || item?.tag?.id === filterTagId;
			const matchesSortType = sortType === SORT_BY_ALL || item?.type === sortType;
			const matchesSearch =
				search === "" || item?.title?.toLowerCase().includes(search.toLowerCase());

			return matchesTag && matchesSortType && matchesSearch;
		});
	}, [toDos, filterTagId, sortType, search]);

	return (
		<div className="p-6 space-y-6">
			<ToDoFilterPanel
				activeTabTagId={filterTagId}
				data={toDos}
				isSortEnabled={false}
				sortOptions={[ToDoType.IMPORTANT, ToDoType.VERY_IMPORTANT]}
				sortType={sortType}
				onFilterClick={setFilterTagId}
				onSearch={handleOnSearch}
				onSort={setSortType}
			/>
			<EditableToDoItemList
				data={filteredData}
				editingToDoId={editingToDoId}
				isLoading={isLoading}
				setEditingToDoId={setEditingToDoId}
			/>
		</div>
	);
}
